import React from 'react';

const LocationMessage = ({ location, replyText, timestamp, isRightSide = false, className = '' }) => {
  const { latitude, longitude } = location || {};
  if (!latitude || !longitude) return null;

  const openInGoogleMaps = () => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
  };

  return (
    <div className={`w-full min-w-[280px] max-w-[280px] ${isRightSide ? 'ml-auto' : ''} ${className}`}>
      {replyText && (
        <div className="w-full flex-row align-center bg-[var(--channelButton)] inbox12px-400 text-[var(--font-600)] b-radius-6 mb-10">
          <div className="h-[6vh] bg-[#6564CA] w-1" />
          <div className="flex flex-1 items-center">
            <div className="max-w-[20ch] truncate ml-2">{replyText}</div>
          </div>
        </div>
      )}

      <div className={`bg-white rounded-lg overflow-hidden border ${isRightSide ? 'border-blue-100' : 'border-gray-200'} shadow-sm`}>
        {/* Map Preview (iframe with overlay) */}
        <div className="relative h-40 bg-gray-100 cursor-pointer" onClick={openInGoogleMaps}>
          <iframe
            title="map-preview"
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
            className="pointer-events-none"
          />
          {/* Overlay to block interaction */}
          <div className="absolute inset-0 bg-transparent" />
        </div>

        {/* Location details */}
        <div className="p-3">
          <div className="flex items-center justify-between min-w-full">
            <div className="flex items-center gap-3 min-w-full">
              {/* <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center">
                <svg className="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
              </div> */}
              <div className="min-w-full">
                <div className="text-sm font-medium text-gray-900">Location</div>
                <div className="flex items-center justify-between min-w-full">
                  <div className="text-xs text-gray-500">Tap to view in Google Maps</div>
                  {timestamp && (
                    <div className="text-[9px] text-gray-500 font-[600]">
                      {timestamp}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationMessage;
